import { OperacaoFormularioCRUD } from "service/restricao/OperacaoFormulario/OperacaoFormulario";
import { RestricoesCamposFormulario } from "service/restricao/RestricoesCamposFormulario";
import { ObjectUtils } from "./ObjectUtils";


export class PatchData {

  constructor(public restricoes: RestricoesCamposFormulario) {}

  /**
   * Retorna somente o que foi alterado
   */
  gerar(atual: any, original: any) {
    const camposEditaveis = Object.keys(this.restricoes).filter(it => {
      // FIXME: Ta amarrado a somente atualização
      const restricoesCampo = this.restricoes[it][OperacaoFormularioCRUD.Atualizar];
      return !(restricoesCampo.disabled || restricoesCampo.readOnly || restricoesCampo.hidden)
    });
    const conteudo: any = {}

    camposEditaveis.forEach(campo => {
      const valorOriginal = ObjectUtils.acessarValor(original, campo)
      const valorAtual = ObjectUtils.acessarValor(atual, campo)
      
      if (valorOriginal !== valorAtual) {
        ObjectUtils.popular(conteudo, valorAtual, campo);
      }
    });

    return conteudo;
  }
}
